export const createSequentialArray = (length: number) =>
  new Array(length).fill(null).map((_, i) => i);
